import React, { useState } from "react";
import { inject, observer } from "mobx-react";
import { Helmet } from "react-helmet";
import Grid from "@material-ui/core/Grid";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import Paper from "@material-ui/core/Paper";
import CircularProgress from "@material-ui/core/CircularProgress";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Typography from "@material-ui/core/Typography";
import UiFormTitle from "../../common/UiFormTitle";
import LabelSummary from "./LabelSummary";
import ImportProjectSummary from "./ImportProjectSummary";
import UiButton from "pages/common/UiButton";
import withContext from "../../../tools/withContext";
import ImportLabelsStore, {
  ImportMode,
} from "store/import-labels-store/importLabelsStore";
import UiInput from "pages/common/UiInput";

const GenerateBatchFromLabels = (props: any) => {
  const { classes, project, history, importLabelsStore, ctx } = props;
  const { appFetch } = ctx;
  const store = importLabelsStore as ImportLabelsStore;
  const [redirecting, setRedirecting] = useState(false);
  const isLoading = store.generating || redirecting;

  return (
    <Grid
      container
      direction="row"
      justify="center"
      alignItems="flex-start"
      className={classes.root}
    >
      <Helmet>
        <title>Générer les lots</title>
      </Helmet>
      <Grid item xs={12} sm={10} md={8} xl={7}>
        <Paper className={classes.paper}>
          <UiFormTitle>{`2. Générer les lots`}</UiFormTitle>
          <Grid
            container
            spacing={16}
            className={classes.form}
            style={{ paddingBottom: 16 }}
          >
            <Grid item xs={12} style={{ paddingLeft: 0, paddingRight: 0 }}>
              <ImportProjectSummary project={project} />
              <LabelSummary result={store.previewResult} showImagePreview />
            </Grid>
            <Grid container direction="row" justify="space-between" xs={12}>
              <Grid item xs={3}>
                <UiInput
                  label="Préfixe des lots"
                  name="batchPrefix"
                  value={store.batchPrefix}
                  onChange={(e: any) => store.setBatchPrefix(e.target.value)}
                />
              </Grid>
              <Grid item xs={3}>
                <UiInput
                  label="Nombre de lots"
                  name="batchCount"
                  value={store.batchCount}
                  onChange={(e: any) => store.setBatchCount(e.target.value)}
                />
              </Grid>
              <Grid item xs={3}>
                <UiInput
                  label="Nombre d'images par lot"
                  name="batchSize"
                  value={store.nbImagesPerBatch}
                  onChange={(e: any) =>
                    store.setNbImagesPerBatch(e.target.value)
                  }
                />
              </Grid>
            </Grid>
            <Grid item xs={12} style={{ marginTop: 8 }}>
              <label
                style={{
                  fontWeight: 200,
                  display: "block",
                  fontSize: 16,
                  marginBottom: 4,
                }}
              >
                Mode d'import :
              </label>
              <RadioGroup
                aria-label="importMode"
                value={store.importMode}
                onChange={(e: any) =>
                  store.setImportMode(e.target.value as ImportMode)
                }
                row
              >
                <FormControlLabel
                  value="COPY"
                  control={<Radio />}
                  label="Copy"
                />
                <FormControlLabel
                  value="LINK"
                  control={<Radio />}
                  label="Link"
                />
              </RadioGroup>
              <Typography
                variant="caption"
                style={{
                  color: "#666",
                  display: "block",
                  marginTop: 2,
                  lineHeight: 1.6,
                }}
              >
                <strong>Copy</strong> — les images sont importées vierges (sans
                labélisation existante).
                <br />
                <strong>Link</strong> — les images sont importées avec leur
                labélisation d'origine.
              </Typography>
            </Grid>
          </Grid>
          <Grid
            item
            container
            justify="space-between"
            xs={12}
            style={{ padding: "20px" }}
          >
            <UiButton
              variant="outlined"
              color="primary"
              onClick={() => store.setStep(1)}
              style={{ height: "42px" }}
            >
              <NavigateBeforeIcon style={{ marginRight: 8 }} />
              Retour
            </UiButton>
            <UiButton
              color={"primary"}
              variant="contained"
              onClick={async () => {
                await store.generate(
                  appFetch,
                  project.id,
                  project.client.id,
                  project.labelingTypes?.[0]?.name,
                );
                if (!store.generateError) {
                  setRedirecting(true);
                  setTimeout(() => history.push("/projectsOperations"), 2000);
                }
              }}
              disabled={
                isLoading ||
                store.batchPrefix === "" ||
                store.batchCount === "" ||
                store.nbImagesPerBatch === ""
              }
              style={{ height: "42px", width: "220px" }}
            >
              {isLoading ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                "Générer les lots"
              )}
            </UiButton>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default withContext(
  inject("importLabelsStore")(observer(GenerateBatchFromLabels)),
);
